import React from 'react'
import {Link} from 'react-router-dom'
import './NavBar.css'

const $ = window.$

export default class NavBar extends React.Component {
    constructor(props) {
        super(props)

        this.state = {}
    }

    componentDidMount() {
        this.props.history.listen(() => {
            window.scrollTo(0, 0)
        })
        $('.nav > li:has(ul)').addClass('drop')
        $('.nav > li.drop > ul').addClass('dropdown')
        $('.nav > li.drop > ul.dropdown ul').addClass('sup-dropdown')
    }

    render() {
        return (
            <div className="navbar navbar-default navbar-top">
                <div className="container">
                    <div className="navbar-header">
                        <button type="button" className="navbar-toggle"
                                data-toggle="collapse"
                                data-target=".navbar-collapse">
                            <i className="icon-menu-1"></i>
                        </button>
                        <Link className="navbar-brand" to="/">
                            <img alt="" src="images/stapmedif_logo_horizontal.png"/>
                        </Link>
                    </div>
                    <div className="navbar-collapse collapse">
                        <ul className="nav navbar-nav navbar-right">
                            <li>
                                <Link to={'/'}
                                      className={!this.props.match.params.active ? 'active' : ''}>Accueil</Link>
                            </li>
                            <li>
                                <Link to={'/about'}
                                      className={this.props.match.params.active === 'about' ? 'active' : ''}>Qui
                                    sommes-nous</Link>
                            </li>
                            <li>
                                <Link to={'/services'}
                                      className={this.props.match.params.active === 'services' ? 'active' : ''}>Nos
                                    prestations</Link>
                            </li>
                            <li>
                                <Link to={'/quality'}
                                      className={this.props.match.params.active === 'quality' ? 'active' : ''}>Nos
                                    engagements</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/NavBar.jsx